import React from 'react';
import { Toaster } from 'react-hot-toast';
import { useResolvedThemeIsDark } from '@/store/theme';

export function ThemedToaster() {
  const isDark = useResolvedThemeIsDark();

  return (
    <Toaster
      position="top-right"
      toastOptions={{
        duration: 4000,
        style: {
          background: isDark ? '#1f2937' : '#ffffff',
          color: isDark ? '#f9fafb' : '#111827',
          border: isDark ? '1px solid #374151' : '1px solid #e5e7eb',
        },
      }}
    />
  );
}
